import React from "react";
import { Grid, Card, Typography } from "@mui/material";

const AnalyticsQuickCards = ({
  exercisesFromReport,
  completedSets,
  totalSets,
  workoutStatus,
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={3}>
        <Card sx={{ p: 2, textAlign: "center", bgcolor: "success.50" }}>
          <Typography variant="h4" fontWeight="bold" color="success.main">
            {workoutStatus === "complete" ? "✓" : completedSets}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {workoutStatus === "complete" ? "Today Complete" : "Sets Completed"}
          </Typography>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card sx={{ p: 2, textAlign: "center", bgcolor: "primary.50" }}>
          <Typography variant="h4" fontWeight="bold" color="primary.main">
            {exercisesFromReport.filter((ex) => ex.completed).length}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Exercises Done Today
          </Typography>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card sx={{ p: 2, textAlign: "center", bgcolor: "warning.50" }}>
          <Typography variant="h4" fontWeight="bold" color="warning.main">
            {exercisesFromReport.length -
              exercisesFromReport.filter((ex) => ex.completed).length}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Exercises Remaining
          </Typography>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <Card sx={{ p: 2, textAlign: "center", bgcolor: "info.50" }}>
          <Typography variant="h4" fontWeight="bold" color="info.main">
            {totalSets > 0 ? ((completedSets / totalSets) * 100).toFixed(0) : 0}
            %
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Today&apos;s Progress
          </Typography>
        </Card>
      </Grid>
    </Grid>
  );
};

export default AnalyticsQuickCards;
